export default __webpack_public_path__ + "static/media/WMIS - KIT_1.86301586.wav";